const newpolicyData = {
'cid':'APCPCID',
'module': 'NEW',
'id':'APCPGID',
'questions':[
  {
    "id": 'APCPEXAMTITLE',
    "question_text": "Exam Title",
    "input_type": "Dropdown",
    "input_options": [
        "w1",
        "w2",
        "w3",
        "w4",
        "w5"
    ],
    "current_value":"",
    "sequence_row": 0,
    "sequence_column": 1,
    "question_group": 189,
    "data_type": null,
    "data_required": true,
    "data_min": null,
    "data_max": null,
    "data_length": null,
    "data_pattern": null,
    "is_archived": null,
    "is_global": null,
    "is_key_data": null,
    "is_pre_populate": null,
    "cell_ids": null,
    "published_at": null,
    "created_by": 1,
    "updated_by": 1,
    "created_at": "2022-01-17T16:55:29.824Z",
    "updated_at": "2022-01-17T17:30:50.909Z",
    "question_tooltip": null,
    "origin": null,
    "question_type": null,
    "api_attribute": "score",
    "api_attribute_desc": null,
    "question_tag": null,
    "is_read_only": null
  },
  {
    "id":'ReadOnly',
    "question_text":'',
    'input_type':'Readonly',
    "sequence_row": 0,
    "sequence_column": 2,
  }
]};

export default newpolicyData;
